import UnlockButton from "./UnlockButton";

// UnlockModal.jsx
export default function UnlockModal({ totalCards, onClose, onUnlock, price }) {
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-xl shadow-xl max-w-sm w-full p-6 text-center">
        <h2 className="text-lg font-semibold text-gray-900">
          You've reached the end of the free preview!
        </h2>
        <p className="text-sm text-gray-700 mt-2">
          Unlock all {totalCards} cards in the full digital deck.
        </p>
        <div className="mt-4 flex flex-col gap-2">
          <UnlockButton onClick={onUnlock} price={price} />
          <button className="text-sm text-gray-500 underline" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
